<template>
  <MetricTile
    v-if="density === 'default'"
    :loading="loading"
    :no-data="!metric"
    :show-duration="false"
    :progress-bar-value="metric?.percentage"
    icon="fa-solid fa-user-graduate"
  >
    <template #title>Subject Choices Selected</template>
    <template #metric>{{ metric.completed }}
    </template>
    <template #overMetric>{{ metric.total }}</template>
    <template #additionalMetric> {{ metric.percentage }}%</template>
  </MetricTile>
  <MiniMetricTile v-else-if="density === 'compact'" color="pink" :loading="loading">
    <template #icon>
      fa-solid fa-user-graduate
    </template>
    <template #metric>
      {{ metric?.completed || 0 }}
    </template>
    <template #title>
      Subject Choices Selected
    </template>
  </MiniMetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import {useMetricTile} from "@/composables/useMetricTile";
import MiniMetricTile from "@/components/Metrics/MiniMetricTile.vue";
import {PropType} from "vue";

const {metric, loading} = useMetricTile<
  {
    completed: number;
    total?: number;
    percentage?: number;
  }>("subject-choice-usage-ratio");
defineProps({
  density: {
    type: String as PropType<"default" | "compact" | "comfortable">,
    default: "default"
  },
});
</script>
